import React from "react";
import * as Icons from "lucide-react";

const IconRender = ({ name, className = "w-5 h-5" }) => {
  const Icon = Icons[name] || Icons.Sparkles;
  return <Icon className={className} />;
};

export default IconRender;
